module.exports = __webpack_public_path__ + "assets/img/help_label.e6cdf4ee.png";